import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../Partials/Layout";
import { useAuth } from "../Context/AuthenticateProvider";

const PrivateRouters = ({ allowedRoles }) => {

    const { isAuthenticated } = useAuth()

    const customer = useSelector(s => s.customer.customer);
    

    if (!customer?.user?.role || !isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(customer?.user?.role)) {
        return <Navigate to="/" replace />;
    }

    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};

export default PrivateRouters;
